import {
  SPEAKER_COLORS,
  UNKNOWN_SPEAKER_COLOR,
} from "../core/transcription/constants";

export function getSpeakerColor(
  speakerId: number | string,
  unknownColor = UNKNOWN_SPEAKER_COLOR,
): string {
  const id = Number(speakerId);
  return id === undefined || id === -1
    ? unknownColor
    : SPEAKER_COLORS[Math.abs(id % SPEAKER_COLORS.length)];
}
